import { Home, MapPin, Wallet, Clock, Sparkles, ArrowUpRight } from "lucide-react";

export default function AIQualificationExample() {
    return (
        <section
            id="qualification-example"
            data-testid="qualification-example-section"
            className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5"
        >
            <div className="max-w-5xl mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-14">
                    <div className="flex items-center gap-3 justify-center mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">AI Lead Qualification</span>
                        <div className="h-px w-10 bg-[#D4AF37]" />
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        How AI helps prioritize <span className="italic text-[#D4AF37]">the right enquiries</span>.
                    </h2>
                    <p className="mt-6 text-white/70 leading-relaxed">
                        AI helps assess enquiries based on location preference, budget, property requirement and
                        purchase timeline — helping sales teams prioritize higher-intent opportunities.
                    </p>
                </div>

                <div data-testid="qualification-example-card" className="hol-card p-8 lg:p-10 relative overflow-hidden">
                    <span className="absolute top-6 right-6 text-[10px] uppercase tracking-widest px-3 py-1 border border-[#D4AF37]/40 text-[#D4AF37]">
                        Illustrative Example
                    </span>

                    <div className="overline !text-white/50">New Buyer Enquiry</div>
                    <h3 className="mt-2 font-serif-display text-2xl">2 BHK · Hyderabad</h3>

                    <div className="mt-8 grid sm:grid-cols-4 gap-4">
                        <ExampleField icon={Home} label="Configuration" value="2 BHK" />
                        <ExampleField icon={MapPin} label="Location" value="Hyderabad" />
                        <ExampleField icon={Wallet} label="Budget" value="₹75L – ₹90L" />
                        <ExampleField icon={Clock} label="Purchase timeline" value="Within 30 days" />
                    </div>

                    <div className="mt-8 pt-8 border-t border-white/10 grid sm:grid-cols-2 gap-6">
                        <div>
                            <div className="overline !text-white/50 mb-2">AI Lead Assessment</div>
                            <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#D4AF37] bg-[#D4AF37]/10 text-[#D4AF37] font-serif-display text-lg">
                                <Sparkles size={16} strokeWidth={1.5} /> High Intent
                            </div>
                        </div>
                        <div>
                            <div className="overline !text-white/50 mb-2">Recommended Action</div>
                            <div className="flex items-center gap-2 text-white/85 font-body">
                                <ArrowUpRight size={16} className="text-[#D4AF37]" strokeWidth={1.5} />
                                Prioritize follow-up
                            </div>
                        </div>
                    </div>
                </div>

                <p className="mt-6 text-xs text-white/40 text-center italic">
                    Illustrative example for demonstration purposes only — not a real customer result.
                </p>
            </div>
        </section>
    );
}

function ExampleField({ icon: Icon, label, value }) {
    return (
        <div className="p-4 border border-white/10 bg-white/[0.03]">
            <div className="flex items-center gap-2 text-white/40">
                <Icon size={13} strokeWidth={1.5} />
                <span className="text-[10px] uppercase tracking-widest">{label}</span>
            </div>
            <div className="mt-2 font-serif-display text-lg text-white">{value}</div>
        </div>
    );
}
